import React, { useState } from 'react';
import moment from 'moment-timezone';
import { Portal } from '@material-ui/core';
import Draggable from 'react-draggable';
import TaskDetails from 'components/Tasks/TaskDetails';
import { useAppSelector } from 'careand-redux/store';

const TaskEditModal = ({ editModal, openEditModal, patient, task, staff, showPatient }) => {
  const taskId = task?.id;
  const uiOptions = useAppSelector((state) => state.ui.uiOptions);

  const [draggableKey] = useState(moment().unix() + taskId);

  function closeModal() {
    openEditModal(false);
  }

  if (!editModal) return null;

  return (
    <Portal container={() => document.querySelector('.staff-modal-container')}>
      <Draggable key={draggableKey} bounds="body" handle=".handle">
        <div className={`task-draggable-wrapper ${uiOptions.join(' ')}`}>
          <TaskDetails
            task={task}
            patient={patient}
            staff={staff}
            showPatient={showPatient !== undefined ? showPatient : true}
            onAddSuccess={closeModal}
            onClose={closeModal}
          />
        </div>
      </Draggable>
    </Portal>
  );
};

export default TaskEditModal;
